import { memo } from 'react';

import { Skeleton } from '@air/component-skeleton';

export const SearchSubSideNavSavedSearchItemSkeleton = memo(() => {
  return (
    <div
      className="flex min-h-8 w-full cursor-progress items-center gap-1.5 px-1.5 py-1"
      data-testid="SEARCH_SUB_SIDE_NAV_SAVED_SEARCH_SKELETON"
    >
      <Skeleton className="size-5 shrink-0" />
      <Skeleton className="h-4 w-3/4" />
    </div>
  );
});

SearchSubSideNavSavedSearchItemSkeleton.displayName = 'SearchSubSideNavSavedSearchItemSkeleton';
